<template>
  <div>
    <!-- Navigation -->
    <navigation-bar></navigation-bar>

    <!-- Hauptinhalt -->
    <div class="container-fluid mt-4">
      <!-- Kopfzeile mit Werten aus postData -->
     <h3>
      Heti diszpécser lista
      <small class="text-muted">
        (diszpécser: {{ postData.diszpecser }},
        dátum: {{ postData.datumtol }} – {{ postData.datumig }})
      </small>
    </h3>

      <!-- Tabelle mit Scrollbalken -->
      <div class="table-responsive-wrapper">
        <table class="table table-striped">
          <thead class="sticky-header">
            <!-- Filterzeile -->
            <tr>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.m_datumtol" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.megrendelo" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.felrako" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.lerako" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.cikk" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.rendszam" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.potkocsi" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.felrakas_napja" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.lerakas_napja" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.fel_suly" type="text" class="form-control" />
                </div>
              </th>
              <th>
                <div class="input-with-icon">
                  <i class="fas fa-search"></i>
                  <input v-model="filters.le_suly" type="text" class="form-control" />
                </div>
              </th>
            </tr>
            <!-- Tabellen-Header -->
            <tr>
              <th>Megr. dátum</th>
              <th>Megrendelő</th>
              <th>Felrakó</th>
              <th>Lerakó</th>
              <th>Cikk</th>
              <th>Rendszám</th>
              <th>Potkocsi</th>
              <th>Felrakás napja</th>
              <th>Lerakás napja</th>
              <th>Fel súly</th>
              <th>Le súly</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="row in filteredDiszpList"
              :key="row.mellek_az"
              @click="openDetails(row)"
              style="cursor:pointer"
            >
              <td>{{ row.m_datumtol }}</td>
              <td>{{ row.megrendelo }}</td>
              <td>{{ row.felrako }}</td>
              <td>{{ row.lerako }}</td>
              <td>{{ row.cikk }}</td>
              <td>{{ row.rendszam }}</td>
              <td>{{ row.potkocsi }}</td>
              <td 
                :class="{ 'cell-missing': !row.felrakas_napja }"
                @click="enableEdit(row, 'felrakas_napja')"
                >
                <template v-if="isEditing(row, 'felrakas_napja')">
                  <input
                    type="date"
                    v-model="editingCell.value"
                    @keyup.enter="saveEdit(row, 'felrakas_napja')"
                    @blur="saveEdit(row, 'felrakas_napja')"
                    @keyup.esc="cancelEdit"
                    class="form-control"
                    autofocus
                  />
                  <button @mousedown.prevent="cancelEdit" class="btn btn-sm btn-light ml-1">✕</button>
                </template>
                <template v-else>
                  {{ row.felrakas_napja }}
                </template>
              </td>

              <td
                :class="{ 'cell-missing': !row.lerakas_napja }"
                @click="enableEdit(row, 'lerakas_napja')"
              >
                <template v-if="isEditing(row, 'lerakas_napja')">
                  <input
                    type="date"
                    v-model="editingCell.value"
                    @keyup.enter="saveEdit(row, 'lerakas_napja')"
                    @blur="saveEdit(row, 'lerakas_napja')"
                    @keyup.esc="cancelEdit"
                    class="form-control"
                    autofocus
                  />
                  <button @mousedown.prevent="cancelEdit" class="btn btn-sm btn-light ml-1">✕</button>
                </template>
                <template v-else>
                  {{ row.lerakas_napja }}
                </template>
              </td>

                <td
                  :class="{ 'cell-missing': row.fel_suly == 0 }"
                  @click="enableEdit(row, 'fel_suly')"
                >
                  <template v-if="isEditing(row, 'fel_suly')">
                    <input
                      type="number"
                      v-model.number="editingCell.value"
                      @keyup.enter="saveEdit(row, 'fel_suly')"
                      @blur="saveEdit(row, 'fel_suly')"
                      @keyup.esc="cancelEdit"
                      class="form-control"
                      min="0"
                      style="width: 75px"
                      autofocus
                    />
                    <button @mousedown.prevent="cancelEdit" class="btn btn-sm btn-light ml-1">✕</button>
                  </template>
                  <template v-else>
                    {{ row.fel_suly }}
                  </template>
                </td>

                <td
                  :class="{ 'cell-missing': row.le_suly == 0 }"
                  @click="enableEdit(row, 'le_suly')"
                >
                  <template v-if="isEditing(row, 'le_suly')">
                    <input
                      type="number"
                      v-model.number="editingCell.value"
                      @keyup.enter="saveEdit(row, 'le_suly')"
                      @blur="saveEdit(row, 'le_suly')"
                      @keyup.esc="cancelEdit"
                      class="form-control"
                      min="0"
                      style="width: 75px"
                      autofocus
                    />
                    <button @mousedown.prevent="cancelEdit" class="btn btn-sm btn-light ml-1">✕</button>
                  </template>
                  <template v-else>
                    {{ row.le_suly }}
                  </template>
                </td>

            </tr>
          </tbody>
        </table>
      </div>

      <button class="btn btn-secondary m-3" @click="goBack">← Vissza</button>
      <button class="btn btn-secondary m-3" @click="resetFilters">Szűrők visszaállítása</button>
    </div>
  </div>
</template>

<script>
import axiosInstance from "@/axiosInstance";
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      diszpList: [],
      filters: {
        m_datumtol: "",
        megrendelo: "",
        felrako: "",
        lerako: "",
        cikk: "",
        rendszam: "",
        potkocsi: "",
        felrakas_napja: "",
        lerakas_napja: "",
        fel_suly: "",
        le_suly: "",
      },

    editingCell: {
         rowKey: null,   // mellek_az
        field: null,
        value: null
      },


      
    };
  },
  computed: {
      ...mapGetters(["getUserData"]),
   postData() {
        return this.$store.getters.getDiszpecserPostData || {};
      },
    filteredDiszpList() {
      return this.diszpList.filter((row) => {
        return Object.keys(this.filters).every((key) => {
          const filterValue = this.filters[key]?.toLowerCase();
          const rowValue = row[key]?.toString().toLowerCase() || "";
          if (!filterValue) return true;
          return rowValue.includes(filterValue);
        });
      });
    },
    fsz() {
        return this.getUserData ? this.getUserData.fsz : null;
    }, 
  },
  
  async mounted() {
    this.fetchDiszpList();
  },

  //****#################################################################################### */
  methods: {

   enableEdit(row, field) {
    console.log('enable',row.mellek_az);
        this.editingCell = {
          rowKey: row.mellek_az,
          field,
          value: row[field]
        };
      },
      isEditing(row, field) {
        return this.editingCell.rowKey === row.mellek_az && this.editingCell.field === field;
      },
      async saveEdit(row, field) {
        // Passende Feld-Zuordnung!
        const fieldTypeMap = {
          felrakas_napja: "felrakasDatum",
          lerakas_napja: "lerakasDatum",
          fel_suly: "felrakoSuly",
          le_suly: "lerakoSuly"
        };
        const fieldType = fieldTypeMap[field];
        if (!fieldType) {
          this.cancelEdit();
          return;
        }

        // Werte setzen wie in WeekTimeLine
        this.selectedTask = row;
        this.fieldType = fieldType;
        this.fieldValue = this.editingCell.value;

        await this.saveFieldValue(); // Deine WeekTimeLine-Methode!
        this.editingCell = { rowKey: null, field: null, value: null };
      },
      cancelEdit() {
        this.editingCell = { rowKey: null, field: null, value: null };
      },

//********************************************** */

    async saveFieldValue() {
      // Sicherstellen, dass Task gesetzt ist

    console.log('vor Speichern:', this.selectedTask);


      const task = this.selectedTask;
      if (!task) {
        alert('Nincs kiválasztott fuvar!');
        return;
      }

      const changedData = {};
      // Felder nach Backend-Konvention
      if (this.fieldType === 'felrakasDatum') {
        changedData.felrakas_napja = this.fieldValue;
        task.felrakas_napja = this.fieldValue;
      }
      if (this.fieldType === 'lerakasDatum') {
        changedData.lerakas_napja = this.fieldValue;
        task.lerakas_napja = this.fieldValue;
      }
      if (this.fieldType === 'felrakoSuly') {
        changedData.fel_suly = this.fieldValue;
        task.fel_suly = this.fieldValue;
      }
      if (this.fieldType === 'lerakoSuly') {
        changedData.le_suly = this.fieldValue;
        task.le_suly = this.fieldValue;
      }

      // Prüfen, ob sich überhaupt etwas geändert hat
      if (Object.keys(changedData).length === 0) {
        return;
      }

      // Neues Datenpaket wie in editTruck.vue
      const postData = {
        az: task.mellek_az,
        fo_az: task.fo_az,         // falls vorhanden, sonst entfernen!
        mod_felh: this.fsz,
        data: changedData,
      };

      console.log('saveFieldValue postData:', postData);

      try {
        await axiosInstance.post('/napi_mellek/update_napimellek.php', postData);

        await this.fetchDiszpList();

      } catch (err) {
        alert("Sikertelen mentés! Nézze meg a konzolt.");
        console.error(err);
      }
    },

//********************************************* */
    resetFilters() {
      this.filters = {
        m_datumtol: "",
        megrendelo: "",
        felrako: "",
        lerako: "",
        cikk: "",
        rendszam: "",
        potkocsi: "",
        felrakas_napja: "",
        lerakas_napja: "",
        fel_suly: "",
        le_suly: "",
      };
    },
    openDetails(row) {
      // Anpassung nach Wunsch – hier z.B. zu editTruck mit mellek_az
      console.log(row);
    //  this.$router.push({ name: "editTruck", params: { mellek_az: row.mellek_az } });
    },
   
    /*********************************************************************************** */
   async fetchDiszpList() {
      const postData = this.$store.getters.getDiszpecserPostData;
      if (!postData || !postData.ceg_az) {
        console.error("Keine gültigen postData im Store gefunden.");
        return;
      }
      try {
        console.log('postData',postData);

        const response = await axiosInstance.post(
          "/megrendeles/heti_lista_diszpecser.php",
          postData
        );
        if (response.status === 200 && response.data && response.data.data) {
          this.diszpList = response.data.data;
        } else {
          console.error("Fehler beim Abrufen der Diszpécser-Liste:", response);
        }
      } catch (error) {
        console.error("API-Fehler:", error);
      }
    },


    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.table-responsive-wrapper {
  max-height: 700px;
  overflow-y: auto;
  position: relative;
}
.sticky-header th {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 2;
}
.table {
  min-width: 1200px;
  border-collapse: collapse;
}
.table th,
.table td {
  padding: 3px;
  text-align: left;
  border: 1px solid #ddd;
  font-size: 12px;
}
h3 {
  margin-bottom: 10px;
}
.input-with-icon {
  position: relative;
}
.input-with-icon i {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  color: #6c757d;
}
.input-with-icon input {
  padding-left: 30px;
  font-size: 12px;
  height: 30px;
}

.cell-missing {
  background: rgb(248, 221, 221) !important;  /* Heller Rotton im Hintergrund */
  color: rgb(248, 2, 2) !important;        /* Rot für die Schrift */
  
}

input.form-control {
  width: 100%;
  min-width: 80px;
  padding: 2px 6px;
  font-size: 12px;
}

</style>
